import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Chip, Divider, IconButton, Tooltip } from '@mui/material';
import { Claims, PermissionName, useNotification, useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import { PrimaryButton } from 'apps/wrapper/src/components/shared/buttons/buttons.styles';
import { useEffect, useState } from 'react';
import { TabContentSection, TabContentSectionTitle } from '../../dev-tools.styles';
import { AccessTokenInput, AccessTokenInputWrapper, ClaimList, ClaimListItem } from './auth-tab.styles';

export const AuthTab = () => {
  const { showSuccess } = useNotification();
  const { getClaims, getAccessToken } = useOidcWithAdmin();
  const [claims, setClaims] = useState<Claims>();
  const [accessToken, setAccessToken] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      setClaims(await getClaims());
      setAccessToken(await getAccessToken());
    })();
  }, []);

  const handleCopyAccessToken = async () => {
    if (!accessToken) return;

    await navigator.clipboard.writeText(accessToken);
    showSuccess('Access token copied to clipboard');
  };

  return (
    <>
      <TabContentSection>
        <TabContentSectionTitle>Access Token</TabContentSectionTitle>
        <AccessTokenInputWrapper>
          <AccessTokenInput
            value={accessToken}
            size="small"
            placeholder="Access Token"
            sx={{ border: 'none' }}
            inputProps={{ style: { padding: 0, fontWeight: '12px', color: 'black' } }}
          />
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <IconButton
            size="small"
            color="primary"
            onClick={handleCopyAccessToken}
            sx={{ p: '10px', width: '32px', height: '32px', margin: '0 2px' }}
          >
            <ContentCopyIcon sx={{ width: '16px', height: '16px' }} />
          </IconButton>
        </AccessTokenInputWrapper>
      </TabContentSection>

      {claims && (
        <TabContentSection>
          <TabContentSectionTitle>Claims</TabContentSectionTitle>
          <ClaimList>
            {Object.keys(claims)
              .filter((key) => key != 'permissions')
              .map((key) => (
                <ClaimListItem key={key}>
                  <strong>{key}</strong>
                  {claims[key as keyof Claims]}
                </ClaimListItem>
              ))}
          </ClaimList>
        </TabContentSection>
      )}

      {claims && claims.permissions && (
        <TabContentSection>
          <TabContentSectionTitle sx={{ marginBottom: '10px' }}>Claims: Permissions</TabContentSectionTitle>
          {claims.permissions.map((perm) => (
            <Tooltip key={perm} title={PermissionName[perm] ?? 'Unknown'} placement="top">
              <Chip label={perm.toString()} sx={{ margin: '4px 4px 0 0px', color: 'black' }} />
            </Tooltip>
          ))}
        </TabContentSection>
      )}

      <TabContentSection>
        <PrimaryButton>Clear Auth Data</PrimaryButton>
      </TabContentSection>
    </>
  );
};
